import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=1cadcf13&scoped=true&"
import script from "./blacklist.vue?vue&type=script&lang=js&"
export * from "./blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cadcf13",
  null
  
)

export default component.exports